import { FormattedMessage } from 'react-intl'
import { iconSizeOptions } from '../../icons/icons-sizes'
import { SpinnerGrey } from '../../icons/special'
import {
  progressBarColorOptions,
  progressBarSizeOptions,
  progressBarVariantOptions
} from '../constants'
import { ProgressContainer } from '../styled-components'
import ProgressBarBar from './progress-bar-bar'
import ProgressBarFooter from './progress-bar-footer'
import ProgressBarHeader from './progress-bar-header'
import ProgressBarLabel from './progress-bar-label'

export const ProgressBarLoading = ({
  size = progressBarSizeOptions.SMALL,
  loadingLabel = null,
  loadingProgressLabel = null,
  loadingHint = null
}) => {
  return (
    <ProgressContainer>
      <ProgressBarHeader>
        <ProgressBarLabel
          labelColor={
            progressBarColorOptions[progressBarVariantOptions.WAITING]
          }
          customLabelStyle={null}
          size={progressBarSizeOptions.SMALL}
        >
          {loadingLabel}
        </ProgressBarLabel>

        <ProgressBarLabel
          labelColor={
            progressBarColorOptions[progressBarVariantOptions.WAITING]
          }
          customLabelStyle={null}
          size={progressBarSizeOptions.SMALL}
        >
          {loadingProgressLabel && `${loadingProgressLabel}%`}
        </ProgressBarLabel>
      </ProgressBarHeader>
      <ProgressBarBar
        progressBarValue={0}
        size={size}
        progressColo={
          progressBarColorOptions[progressBarVariantOptions.WAITING]
        }
      />
      <ProgressBarFooter>
        <SpinnerGrey size={iconSizeOptions['ICON-S']} />
        <ProgressBarLabel
          labelColor={
            progressBarColorOptions[progressBarVariantOptions.WAITING]
          }
          size={progressBarSizeOptions.SMALL}
        >
          {loadingHint ?? <FormattedMessage id="loading" />}
        </ProgressBarLabel>
      </ProgressBarFooter>
    </ProgressContainer>
  )
}
